import { notification } from 'antd';
import { getGeoStores } from './service';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang, gtm, useState, useRouter } = useGlobal();
    const { t } = useLang('RV');
    const { locale } = useRouter();
    const [msg, setMsg] = useState('');
    const [input, setInput] = useState('');
    const [zipCode, setZipCode] = useState('4180023');
    const [showLocation, setShowLocation] = useState(false);
    const [tip, setTip] = useState(1); // 1 正常 2 太远 > 100km 3 无数据

    notification.config({
        placement: 'bottomRight',
        bottom: 60,
        duration: 3,
    });

    const arr = [
        {
            name: 'Gone Mobile Vans',
            address: '1725 Monrovia Ave c3, Costa Mesa, CA 92627',
            phone: '+1 818 519 9805',
            webLink: 'https://www.gonemobilevans.com/',
            distanceKm: 1.2,
        },
        {
            name: 'Paradigm Outdoors DBA Grit Overland',
            address: '4035 S Grant St Unit 115 Washougal, WA 98671',
            phone: '+1 360 910 4282',
            webLink: 'https://gritoverland.com/',
            distanceKm: 24,
        },
        {
            name: 'Main Line Overland Mid-Atlantic',
            address: '917 Old Fern Hill Rd #200, West Chester, PA 19380',
            phone: '+1 844 656 7626',
            webLink: 'http://www.mainlineoverland.com/',
            distanceKm: 55.86,
        },
    ];

    const [results, setResults] = useState(arr);

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        setShowLocation(false);
        msg && setMsg('');
    };

    const handleOnFocus = () => {
        msg && setMsg('');
        setShowLocation(true);
    };

    const hanldeOnBlur = () => {
        setTimeout(() => {
            setShowLocation(false);
        }, 200);
    };

    const handleGetCurrentLocation = async () => {
        if (!window.navigator.geolocation) {
            notification.error({ message: 'Geolocation is not supported by this browser!' });
        } else {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    setZipCode(`Latitude: ${latitude}, Longitude: ${longitude}`);
                    getLocaltionStores({ latitude, longitude });
                },
                (error) => {
                    console.error('Error getting location:', error);
                },
            );
        }
    };

    const handleSubmit = () => {
        const zipCodeRegex = /^[\d-]+$/;
        if (!zipCodeRegex.test(input) || !input) {
            return setMsg(t('G_input_error'));
        }
        setZipCode(input.trim());
        getLocaltionStores({ zipCode: input.trim() });
    };

    const getLocaltionStores = async (params: any) => {
        try {
            const res = await getGeoStores(params, locale);
            if (res?.code === '0') {
                setInput('');
                setMsg('');
                setResults(res?.data);
                if (res?.data?.length <= 0) {
                    setTip(3);
                } else if (res?.data?.every((item: any, k: number) => item?.distanceKm > 100)) {
                    setTip(2);
                } else {
                    setTip(1);
                }
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'find_installer',
                        type: '用户搜索安装程序',
                        button_name: t('G_btn'),
                    });
                } catch (e) {
                    console.error(e);
                }
            } else {
                setMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'find_installer',
                    type: '用户搜索安装程序',
                    button_name: t('G_btn'),
                });
            }
        } catch (e) {
            setMsg(e);
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'find_installer',
                type: '用户搜索安装程序',
                button_name: t('G_btn'),
            });
        }
    };

    return (
        <div id="RV-G" className={`RV-G RV-box ${css['RV-G']}`}>
            <div className="info-box">
                <p className="title">
                    {t.rich('G_title', {
                        b: (text: string) => <span className="blue">{text}</span>,
                    })}
                </p>
                <p className="desc">{t('G_desc')}</p>
                <div className="control">
                    <input
                        type="text"
                        className="input"
                        value={input}
                        onFocus={handleOnFocus}
                        onBlur={hanldeOnBlur}
                        onChange={handleInputChange}
                        placeholder={t('G_placeholder')}
                    />
                    <button className="btn" onClick={handleSubmit}>
                        {t('G_btn')}
                    </button>
                    {showLocation && (
                        <div className="location-box" onClick={handleGetCurrentLocation}>
                            <svg className="location-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                                <path
                                    d="M25.311 7.08857L5.24107 15.9193L14.4594 17.9402L16.4802 27.1585L25.311 7.08857Z"
                                    stroke="#707070"
                                    strokeWidth="1.5"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <span className="location-text">{t('G_location')}</span>
                        </div>
                    )}
                    {msg && <p className="error-msg">{msg}</p>}
                </div>
            </div>
            {results?.length > 0 && (
                <ul className="cards">
                    {results?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            {card?.name && <p className="card-name">{card?.name}</p>}
                            <div className="card-info">
                                {card?.address && (
                                    <div className="card-item card-address">
                                        <svg className="address-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M4 5.5L9 4.5L15 7.5L20 5.5V18L15 20L9 17L4 18V5.5Z"
                                                stroke="#707070"
                                                strokeWidth="1.5"
                                                strokeLinejoin="round"
                                            />
                                            <path d="M9 4.5V17" stroke="#707070" strokeWidth="1.5" />
                                            <path d="M15 7V19.5" stroke="#707070" strokeWidth="1.5" />
                                        </svg>
                                        <span className="card-text">{card?.address}</span>
                                    </div>
                                )}
                                {card?.phone && (
                                    <div className="card-item card-phone">
                                        <svg className="phone-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M19.9995 15.9791V18.3877C20.0004 18.6113 19.9545 18.8327 19.8648 19.0375C19.775 19.2424 19.6434 19.4263 19.4783 19.5775C19.3132 19.7286 19.1183 19.8437 18.906 19.9154C18.6938 19.987 18.4689 20.0136 18.2457 19.9935C15.7702 19.725 13.3923 18.8808 11.3031 17.5286C9.35937 16.2959 7.71141 14.6512 6.47627 12.7113C5.11669 10.6168 4.27059 8.23206 4.00653 5.75036C3.98643 5.52834 4.01286 5.30457 4.08416 5.0933C4.15546 4.88203 4.27005 4.6879 4.42065 4.52325C4.57124 4.35861 4.75454 4.22706 4.95886 4.13699C5.16319 4.04691 5.38407 4.00029 5.60744 4.00008H8.02086C8.41128 3.99624 8.78977 4.13422 9.0858 4.3883C9.38182 4.64237 9.57517 4.99521 9.62981 5.38103C9.73168 6.15185 9.92059 6.9087 10.1929 7.63713C10.3012 7.9245 10.3246 8.23682 10.2604 8.53707C10.1963 8.83732 10.0472 9.11292 9.83093 9.33121L8.80925 10.3509C9.95446 12.3609 11.6221 14.0252 13.6361 15.1682L14.6578 14.1485C14.8765 13.9326 15.1527 13.7839 15.4535 13.7198C15.7544 13.6558 16.0673 13.6792 16.3552 13.7872C17.0851 14.059 17.8435 14.2476 18.6158 14.3492C19.0066 14.4042 19.3635 14.6007 19.6186 14.9012C19.8737 15.2017 20.0093 15.5853 19.9995 15.9791Z"
                                                stroke="#707070"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <a href={`tel:${card?.phone}`} className="card-text link">
                                            {card?.phone}
                                        </a>
                                    </div>
                                )}
                                {card?.webLink && (
                                    <div className="card-item card-webLink">
                                        <svg className="webLink-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H15.6M12 21C7.02944 21 3 16.9706 3 12M12 21C13.9882 21 15.6 16.9706 15.6 12M12 21C10.0118 21 8.4 16.9706 8.4 12M3 12C3 7.02944 7.02944 3 12 3M3 12H8.4M12 3C10.0118 3 8.4 7.02944 8.4 12M12 3C13.9882 3 15.6 7.02944 15.6 12M15.6 12H8.4"
                                                stroke="#707070"
                                                strokeWidth="1.5"
                                            />
                                        </svg>

                                        <a href={`${card?.webLink}`} className="card-text link webLink">
                                            {card?.webLink}
                                        </a>
                                    </div>
                                )}
                                {card?.distanceKm >= 0 && (
                                    <div className="card-item card-distance">
                                        <svg
                                            className="distance-icon"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M7.24443 15.4895C5.27607 15.9943 4 16.8047 4 17.7182C4 19.2488 7.58172 20.4895 12 20.4895C16.4183 20.4895 20 19.2488 20 17.7182C20 16.8222 18.7724 16.0255 16.8681 15.5189"
                                                stroke="#707070"
                                                strokeWidth="1.6"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M17.25 8.83337C17.25 12.9167 12 16.4167 12 16.4167C12 16.4167 6.75 12.9167 6.75 8.83337C6.75 7.44099 7.30312 6.10563 8.28769 5.12106C9.27226 4.1365 10.6076 3.58337 12 3.58337C13.3924 3.58337 14.7277 4.1365 15.7123 5.12106C16.6969 6.10563 17.25 7.44099 17.25 8.83337Z"
                                                stroke="#707070"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M12 10.5834C12.9665 10.5834 13.75 9.79987 13.75 8.83337C13.75 7.86688 12.9665 7.08337 12 7.08337C11.0335 7.08337 10.25 7.86688 10.25 8.83337C10.25 9.79987 11.0335 10.5834 12 10.5834Z"
                                                stroke="#707070"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                        <span className="card-text">
                                            {t.rich('G_distance', {
                                                d: card?.distanceKm,
                                            })}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
            {results?.length === 0 && (
                <svg className="nodata-icon" width="167" height="137" viewBox="0 0 167 137" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.3597 51.0837C10.3597 51.0837 12.4963 45.5568 17.7485 47.726C18.9609 46.559 20.4616 45.7109 22.4906 46.0926C24.5197 46.4744 25.8282 47.9168 26.272 48.8756C26.9079 48.8474 32 49.0079 32 54.0164C32 59.0248 25.8373 58.9294 25.3913 58.5324C24.8422 58.9966 22.2024 61.515 18.9998 58.6409C18.3067 59.2027 16.042 61.5822 12.462 58.2982C10.8035 58.9554 6.86207 59.4608 6.09803 55.602C5.33399 51.7453 9.25256 50.6564 10.3597 51.0837Z"
                        fill="url(#paint0_linear_360_22643)"
                    />
                    <path
                        d="M129.707 25.3518C129.707 25.3518 132.994 16.272 141.075 19.8355C142.94 17.9183 145.249 16.525 148.37 17.1522C151.492 17.7829 153.505 20.1491 154.188 21.7242C155.166 21.6778 163 21.9415 163 30.1697C163 38.3979 153.519 38.2411 152.833 37.589C151.988 38.3516 147.927 42.4889 143 37.7672C141.933 38.6901 138.449 42.5993 132.942 37.2041C130.39 38.2839 124.326 39.1142 123.151 32.7747C121.975 26.4387 128.004 24.6498 129.707 25.3518Z"
                        fill="url(#paint1_linear_360_22643)"
                    />
                    <path
                        d="M83.5 137C129.616 137 167 119.315 167 97.5C167 75.6848 129.616 58 83.5 58C37.3842 58 0 75.6848 0 97.5C0 119.315 37.3842 137 83.5 137Z"
                        fill="url(#paint2_linear_360_22643)"
                    />
                    <g clipPath="url(#clip0_360_22643)">
                        <path
                            d="M80.0891 57.9442L85.7665 54.0446L85.7325 53.9782C90.613 51.1405 89.2837 38.6148 82.6794 25.7309C75.9816 12.6645 66.3945 4.17774 61.266 6.77516C61.201 6.80806 61.1369 6.84257 61.0738 6.87852L55.0005 8.99976L56.3646 11.6621C61.029 10.8164 68.899 18.435 74.6332 29.6214C80.3674 40.8078 81.9423 51.6147 78.5123 54.8686L80.0891 57.9442Z"
                            fill="#B2BECB"
                        />
                        <path
                            d="M57.5445 38.4722C64.4726 51.9878 74.4824 60.7191 79.9021 57.9743C85.3218 55.2294 84.0989 42.0476 77.1708 28.532C70.2427 15.0164 60.2329 6.28505 54.8132 9.02994C49.3935 11.7748 50.6163 24.9566 57.5445 38.4722ZM58.7503 37.6608C52.6105 25.6831 51.3117 14.1103 55.8492 11.8122C60.3867 9.51413 69.0423 17.361 75.1821 29.3386C81.3218 41.3163 82.6207 52.889 78.0832 55.1871C73.5457 57.4852 64.8901 49.6384 58.7503 37.6608Z"
                            fill="#C9D2E3"
                        />
                        <mask id="mask0_360_22643" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="52" y="11" width="30" height="46">
                            <path
                                d="M75.2339 29.6696C81.4062 41.7108 82.8152 53.2927 78.3809 55.5385C73.9466 57.7843 65.3483 49.8436 59.176 37.8025C53.0037 25.7613 51.5947 14.1794 56.029 11.9336C60.4632 9.68777 69.0616 17.6285 75.2339 29.6696Z"
                                stroke="#060606"
                            />
                        </mask>
                        <g mask="url(#mask0_360_22643)">
                            <g filter="url(#filter0_f_360_22643)">
                                <path
                                    d="M75.2339 29.6696C81.4062 41.7108 82.8152 53.2927 78.3809 55.5385C73.9466 57.7843 65.3483 49.8436 59.176 37.8025C53.0037 25.7613 51.5947 14.1794 56.029 11.9336C60.4632 9.68777 69.0616 17.6285 75.2339 29.6696Z"
                                    stroke="#060606"
                                />
                            </g>
                        </g>
                        <path
                            d="M84.3224 52.7725C85.1794 52.1979 86.0308 51.9199 86.3772 52.0773L86.4126 52.0536L91.3459 59.3238L92.8965 58.2842L110.402 84.0821L110.384 84.0947C110.422 84.125 110.455 84.1599 110.482 84.1994C110.894 84.8065 109.74 86.2962 107.906 87.5263C106.071 88.7565 104.249 89.2616 103.837 88.6544C103.81 88.6149 103.79 88.5714 103.776 88.5247L103.758 88.5371L86.2519 62.7396L87.802 61.6999L82.8686 54.4297L82.9042 54.4058C82.8866 54.0275 83.4651 53.3473 84.3224 52.7725Z"
                            fill="#B2BECB"
                        />
                        <mask id="mask1_360_22643" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="82" y="52" width="29" height="37">
                            <g opacity="0.423">
                                <path
                                    d="M84.3224 52.7725C85.1794 52.1979 86.0308 51.9199 86.3772 52.0773L86.4126 52.0536L91.3459 59.3238L92.8965 58.2842L110.402 84.0821L110.384 84.0947C110.422 84.125 110.455 84.1599 110.482 84.1994C110.894 84.8065 109.74 86.2962 107.906 87.5263C106.071 88.7565 104.249 89.2616 103.837 88.6544C103.81 88.6149 103.79 88.5714 103.776 88.5247L103.758 88.5371L86.2519 62.7396L87.802 61.6999L82.8686 54.4297L82.9042 54.4058C82.8866 54.0275 83.4651 53.3473 84.3224 52.7725Z"
                                    fill="#353941"
                                />
                            </g>
                        </mask>
                        <g mask="url(#mask1_360_22643)">
                            <path
                                opacity="0.423"
                                d="M74 56L86.4589 47.6468L86.4309 51.6221C85.5436 54.3125 85.3119 57.2212 85.7549 60.1077L86.0971 62.3367L74 56Z"
                                fill="#353941"
                            />
                        </g>
                    </g>
                    <path
                        d="M120.185 50.6306C120.185 50.6306 121.746 46.6814 125.585 48.2333C126.471 47.3985 127.566 46.7927 129.051 47.0667C130.536 47.3407 131.49 48.3702 131.813 49.0531C132.277 49.0338 136 49.1472 136 52.724C136 56.3007 131.497 56.2322 131.171 55.9497C130.769 56.2814 128.841 58.0795 126.499 56.0289C125.993 56.4291 124.338 58.1308 121.723 55.7849C120.511 56.2536 117.631 56.6154 117.072 53.8584C116.511 51.1036 119.377 50.3245 120.185 50.6306Z"
                        fill="url(#paint3_linear_360_22643)"
                    />
                    <defs>
                        <filter
                            id="filter0_f_360_22643"
                            x="48.9414"
                            y="7.05457"
                            width="36.5273"
                            height="53.363"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_360_22643" />
                        </filter>
                        <linearGradient id="paint0_linear_360_22643" x1="19.0001" y1="60.0015" x2="19.0001" y2="46.0018" gradientUnits="userSpaceOnUse">
                            <stop offset="0.2332" stopColor="white" />
                            <stop offset="1" stopColor="#D3DFEE" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_360_22643" x1="143" y1="40.0023" x2="143" y2="17.0028" gradientUnits="userSpaceOnUse">
                            <stop offset="0.2332" stopColor="white" />
                            <stop offset="1" stopColor="#D3DFEE" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_360_22643" x1="83.4991" y1="137" x2="83.4991" y2="57.9981" gradientUnits="userSpaceOnUse">
                            <stop offset="0.526482" stopColor="white" />
                            <stop offset="1" stopColor="#DAE4EF" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_360_22643" x1="126.499" y1="56.9997" x2="126.499" y2="47" gradientUnits="userSpaceOnUse">
                            <stop offset="0.2332" stopColor="white" />
                            <stop offset="1" stopColor="#D3DFEE" />
                        </linearGradient>
                        <clipPath id="clip0_360_22643">
                            <rect width="67" height="91" fill="white" transform="translate(44)" />
                        </clipPath>
                    </defs>
                </svg>
            )}
            {tip === 1 && (
                <p className="tip">
                    {t.rich('G_tip_join', {
                        a: (text: string) => (
                            <a href={`/cooperation`} className="tip-link" target="_blank" rel="noreferrer">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            )}
            {tip === 2 && (
                <p className="tip y">
                    {t.rich('G_tip_apologize', {
                        a: (text: string) => (
                            <a href={`mailto:${text}`} className="tip-link">
                                {text}
                            </a>
                        ),
                    })}
                </p>
            )}
            {tip === 3 && (
                <div className="nodata tip">
                    {t.rich('G_tip_nodata', {
                        zipCode,
                        s: (text: string) => <p className="s">{text}</p>,
                        a: (text: string) => (
                            <a href="/" className="tip-link">
                                {text}
                            </a>
                        ),
                    })}
                </div>
            )}
        </div>
    );
}
